/* @flow */

import { Endpoint } from '../constants/Endpoints'
import Endpoints from '../constants/Endpoints';
import Environments from '../constants/Environments';
import { getDeepPropertyValue } from './WidgetUtils';

const endpointTarget = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL'
};

export function getEndpointURL(settings: Object, endpoint: string, previewModeConsumer?: string): string {
  const { env, previewModeDLB, previewModeSBX } = settings;
  const target = previewModeDLB || previewModeSBX ? endpointTarget.INTERNAL : endpointTarget.EXTERNAL;
  const mappedEnv = envMapping.get(env);

  return (previewModeDLB || previewModeSBX) && previewModeConsumer ?
    getDeepPropertyValue([ target, previewModeConsumer, endpoint, mappedEnv ], Endpoints) || '' :
    getDeepPropertyValue([ target, endpoint, mappedEnv ], Endpoints) || ''
}

export function getCMSEndpointURL(settings: Object, widgetEnv: Object) {
  if (settings.previewModeDLB) return getEndpointURL(settings, Endpoint.CMS, PreviewModeConsumers.DLB);
  else if (settings.previewModeSBX) return widgetEnv.configurationServiceEndpointInternal;
  else return widgetEnv.configurationServiceEndpointExternal;
}

export function getDMSEndpointURL(settings: Object, widgetEnv: Object) {
  if (settings.previewModeDLB) return getEndpointURL(settings, Endpoint.DMS, PreviewModeConsumers.DLB);
  else if (settings.previewModeSBX) return widgetEnv.dealerServiceEndpointInternal;
  else return widgetEnv.dealerServiceEndpointExternal;
}

const envMapping: Map<string, string> = new Map([
  [ Environments.ENV_E2E, 'E2E_TESTING' ],
  [ Environments.ENV_TESTING, 'UNIT_TESTING' ],
  [ Environments.ENV_LOCAL, 'LOCAL' ],
  [ Environments.ENV_DEV, 'DEV' ],
  [ Environments.ENV_TEST, 'TEST' ],
  [ Environments.ENV_INT, 'INT' ],
  [ Environments.ENV_PROD, 'PROD' ]
]);

export const PreviewModeConsumers = {
  DLB: 'DLB',
  SPA: 'SPA',
  DSW: 'DSW',
  DDW: 'DDW'
};
